import React from "react";
import EcoOrganism from "./EcoOrganism";
import ActorsList from "./ActorsList";

const OtherActors = () => {
  return (
    <div>
      <EcoOrganism />
      <ActorsList />
    </div>
  );
};

export default OtherActors;
